import LegalPage from "@/pages/LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms & Conditions" subtitle="Legal" testId="terms-page">
      <p>Welcome to THE FABRICS. By accessing or using our website, you agree to be bound by the following terms. Please read them carefully.</p>

      <h2>1. General</h2>
      <p>The Fabrics ("we", "our", "us") operates <a href="https://thefabrics.in">thefabrics.in</a>. By using our site, you confirm that you are at least 18 years old or accessing under the supervision of a parent/legal guardian.</p>

      <h2>2. Products &amp; Pricing</h2>
      <ul>
        <li>All prices are listed in Indian Rupees (₹) and are inclusive of taxes unless stated otherwise.</li>
        <li>We reserve the right to modify prices, product availability, and offers without notice.</li>
        <li>Product colors may vary slightly due to monitor settings and lighting.</li>
      </ul>

      <h2>3. Orders</h2>
      <p>Placing an order constitutes an offer to purchase. We reserve the right to accept, cancel, or refuse any order at our sole discretion (e.g. suspected fraud, pricing errors, out-of-stock items).</p>

      <h2>4. Payments</h2>
      <p>We accept payments via Razorpay (UPI, cards, netbanking) and Cash on Delivery across India. All online payments are processed through PCI-DSS compliant partners.</p>

      <h2>5. Intellectual Property</h2>
      <p>All content, designs, logos, and product photography on this site are the property of THE FABRICS and may not be reproduced without written permission.</p>

      <h2>6. Limitation of Liability</h2>
      <p>THE FABRICS is not liable for any indirect, incidental, or consequential damages arising from the use of our products or website.</p>

      <h2>7. Governing Law</h2>
      <p>These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts of Haryana.</p>

      <h2>8. Contact</h2>
      <p>THE FABRICS · Dharuhera, Haryana, India · <a href="mailto:thefabrics37@gmail.com">thefabrics37@gmail.com</a> · +91 97299 27206.</p>
    </LegalPage>
  );
}
